module.exports = __webpack_public_path__ + "img/lucas-shigihara.8a3897e1.jpg";